import { useRecoilCallback } from 'recoil';
import { PointMm } from '~/domain/geometry/patientGeometry';
import { updateAnnotation } from '~/state/atoms/annotationListAtoms';
import { measurementListState } from '~/state/atoms/measurementAtoms';
import { updateMeasurementPoint } from '~/domain/measurement/measurementEdit';

/**
 * Returns a setter that moves one point of a committed measurement and
 * recomputes its cached value, replacing that measurement's record.
 *
 * Degenerate edits (an angle whose points become coincident) are rejected:
 * the prior record is kept, so the on-image value never flickers to a
 * non-finite angle mid-drag.
 */
export function useUpdateMeasurementPoint(): (
    id: string,
    pointIndex: number,
    point: PointMm
) => void {
    return useRecoilCallback(
        (callback) => (id: string, pointIndex: number, point: PointMm) => {
            updateAnnotation(
                callback,
                measurementListState,
                id,
                (measurement) =>
                    updateMeasurementPoint(measurement, pointIndex, point) ??
                    measurement
            );
        },
        []
    );
}
